// Datatable initialization

function export_redirect(export_type) {
  if (window.location.search) {
    var redirect_url = window.location.search + '&export=' + export_type
  } else {
    var redirect_url = '?export=' + export_type
  }
  window.location = redirect_url
}

function datatable_init() {
  $('table.datatable').each(function () {
    let options = {};
    let buttons_data = $(this).data('table-buttons');
    let buttons = [];
    let button_types = [];
    if (buttons_data) {
      button_types = buttons_data.toString().split(',');
    }

    for (let i = 0; i < button_types.length; i++) {
      switch (button_types[i]) {
        case 'copy':
          buttons.push('copy');
          break;
        case 'csv':
          buttons.push('csv');
          break;
        case 'tsv':
          buttons.push({
            text: 'TSV',
            extend: 'csvHtml5',
            fieldSeparator: '\t',
            extension: '.tsv'
          });
          break;
        case 'export-csv':
          buttons.push({
            text: 'CSV',
            action: function (e, dt, button, config) {
              export_redirect('csv');
            },
          });
          break;
        case 'export-tsv':
          buttons.push({
            text: 'TSV',
            action: function (e, dt, button, config) {
              export_redirect('tsv');
            },
          });
          break;
        case 'export-xlsx':
          buttons.push({
            text: 'XLSX',
            action: function (e, dt, button, config) {
              export_redirect('xlsx');
            },
          });
          break;
        default:
          console.warn('Unknown export button type: ' + buttons[i]);
      }
    }

    if ($(this).data('searching-columns') == '1') {
      options['dom'] = 'rtip';
    } else {
      options['dom'] = 'frtip';
    }

    if (buttons.length) {
      options['buttons'] = buttons;
      options['dom'] = 'B' + options['dom'];
    }

    if ($(this).data('page-length') === -1) {
      options['paging'] = false;
    }

    if ($(this).hasClass('no-order')) {
      options['aaSorting'] = [];
    }

    options['columnDefs'] = [];

    if ($(this).hasClass('no-order-last-column')) {
      options['columnDefs'].push({
        'targets': -1,
        'orderable': false,
      });
    }

    let sort_desc_default = $(this).data('sort-desc-default');
    if (sort_desc_default !== undefined) {
      options['columnDefs'].push({
        'targets': sort_desc_default.toString().split(',').map(Number),
        'orderSequence': ['desc', 'asc', ''],
      });
    }

    let file_size_info = $(this).data('file-size-column');
    if (file_size_info) {
      let file_size_col = file_size_info.toString().split(',');
      let file_size_column = parseInt(file_size_col[0]);
      let file_size_order = ['asc', 'desc'];
      if (file_size_col[1] !== undefined && file_size_col[1] == 'desc') {
        file_size_order = ['desc', 'asc'];
      }
      options['columnDefs'].push({
        'targets': file_size_column,
        'type': 'file-size',
        'orderSequence': file_size_order,
      });
    }

    let url = new URL(window.location.href);
    let search_word = url.searchParams.get('datatable-search');
    if (search_word) {
      options['search'] = {
        'search': search_word
      };
    }

    let ajax = $(this).data('ajax');
    if (ajax) {
      options['processing'] = true;
      options['serverSide'] = true;
    }

    options['language'] = {
      search: '',
      searchPlaceholder: 'Type to search...',
    }

    options['initComplete'] = function () {
      if ($(this).data('searching-columns') == '1') {
        this.api()
          .columns()
          .every(function () {
            let column = this;
            // let title = column.header().textContent;
            let field = $(column.header()).data('field');
            if (field) {
              let input = document.createElement('input');
              input.placeholder = 'search...';
              input.classList.add('input', 'is-small', 'is-block', 'mt-1');
              input.style.width = '90%';
              column.header().appendChild(input);
              input.addEventListener('keydown', (e) => {
                if (e.key === 'Enter') {
                  if (column.search() !== input.value) {
                    column.search(input.value).draw();
                  }
                }
              });
              // Prevent sorting when pressing Enter
              input.addEventListener('keypress', (e) => {
                if (e.key === 'Enter') {
                  e.stopPropagation();
                }
              });
              // Prevent sorting when clicking on the input
              input.addEventListener('click', (e) => {
                e.stopPropagation();
              });
            }
          });
      }
    }

    var table = new DataTable(this, options);
    table.on('init', function () {
      if (typeof initPopovers === 'function') {
        initPopovers();
      }
    });
  });
}

$(function () {
  datatable_init();
});
